<template>
    <div class="modal-container">
        <div class="shadow" @click="closeModal($event)">
            <div class="modal-main-container">
                <div class="modal-header main-background-style custom-bg-color">
                    <span class="title">{{ title }}</span>
                </div>
                <div class="close-div"><img @click="close" class="close-img" :src="require('@/assets/image/questionnaire/common/close.png')" alt=""></div>
                <div class="modal-body"><div v-html="body"></div></div>
                <div class="modal-footer" v-if="footer && footer.length > 0">
                    <button v-for="(button, index) in footer" :key="index" :class="[button['type'], `${button['type'] === 'normal' ? 'main-background-style custom-bg-color' : ''}`]" @click="button['event']">{{ button['text'] }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

// @title: show the title text of the modal.
// @body: show the body text of the modal. (support render text to html by v-html)
// @footer: show the footer buttons. (better no more than 2 buttons)
// @value: control the modal show or hide.

export default {
  props: ['title', 'body', 'footer', 'value'],
  data () {
    return {
      fullShadow: '',
      internalShowModal: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value (val) {
      this.internalShowModal = val
    },
    internalShowModal (val) {
      this.$emit('change', val)
    }
  },
  created () {
    this.internalShowModal = this.value
  },
  methods: {
    close () {
      this.internalShowModal = false
    },
    closeModal (e) {
      if (e.target.className === 'shadow') {
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '~@/assets/icomoon/style.css';
@import '@/assets/scss/questionnaire-common.scss';
$header-height: 50px;
$footer-height: 80px;
$modal-body-height: 500px;
.modal-container {
    height: 100%;
    z-index: 107;
    ::-webkit-scrollbar {
        display: none;
    }
    .shadow {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .modal-main-container {
            width: 95%;
            background-color: transparent;
            .modal-header {
                color: white;
                height: $header-height;
                text-align: center;
                font-size: large;
                display: flex;
                justify-content: center;
                align-items: center;
                border-bottom: none;
                user-select: none;
            }
            .close-div {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-right: 0;
                height: $header-height;
                position: relative;
                top: -$header-height;
                right: 20px;
                user-select: none;
                .close-img {
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                }
            }
            .modal-body {
                user-select: none;
                overflow-y: scroll;
                padding: 20px;
                max-height: $modal-body-height;
                position: relative;
                top: -$header-height;
                font-size: medium;
                background-color: white;
            }
            .modal-footer {
                position: relative;
                top: -$header-height;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: $footer-height;
                background-color: white;
                border: none;
                .button {
                    border: none;
                    height: 40px;
                    color: white;
                }
                .gray {
                    @extend .button;
                    background-color: gray;
                }
                .normal {
                    @extend .button;
                }
            }
        }
    }
}

/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .modal-main-container {
        width: 30rem !important;
        .modal-header {
            padding: 0 50px !important;
            height: $header-height !important;
            font-size: large !important;
        }
        .close-div {
            padding-right: 10px !important;
            height: $header-height !important;
            top: -$header-height !important;

        }
        .modal-body {
            top: -$header-height !important;
            font-size: medium !important;
        }
    }
}

</style>
